import en from './en.json';
import ar from './ar.json';
    export const changeLanguage = (language,title) => {
// console.log('siteLanguage',language,'',title)
    if(language === 'ar'){
        return ar[title];
    }else{
        return en[title];
    }
  }